import React, { useRef } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";

const Map = () => {
  const mapRef = useRef(null);
  const latitude = 31.27952389422965;
  const longitude = 74.17923794232856;
  const position = [latitude, longitude];

    const handleClick = () => {
    if (mapRef.current) {
        window.open("https://www.google.com/maps/place/K-Pack+Pvt+Ltd/data=!4m7!3m6!1s0x391855cf87640573:0x11cad2d59db1a51e!8m2!3d31.2793726!4d74.1792594!16s%2Fg%2F11f7swy950!19sChIJcwVkh89VGDkRHqWxndXSyhE?authuser=0&hl=en&rclk=1")
    }
  };

  return (
    <MapContainer
    scrollWheelZoom={false}
      attributionControl={false}
      center={[latitude, longitude]}
      zoom={13}
      ref={mapRef}
      style={{ height: "75vh", width: "100%" }} // Responsive height and full width
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <Marker
        eventHandlers={{
          click: () => handleClick()
        }}
        position={position}
      >
        <Popup>K-Pack Pvt Limited</Popup>
      </Marker>
    </MapContainer>
  );
};

export default Map;
